import React, { useEffect, useState } from "react";
import { Box, FormControl, FormLabel, NumberInput, NumberInputField } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import { ContentArea } from "./ContentArea";
import { useFocus } from "./useFocus";
const defaults = {
    flex: 1,
    children: []
};
function isStackItem(element) {
    return element.type === "stackItem";
}
export const StackItemContentElement = (props) => {
    var _a, _b, _c;
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    // If a child element of me is selected, activate me too
    const childFocus = useFocus(isStackItem(props.contentElement) ? (_c = (_b = (_a = props.contentElement.data) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null : null);
    const combinedContainerProps = Object.assign(Object.assign({}, childFocus.containerProps), containerProps);
    const combinedIsActive = childFocus.isActive || isActive;
    useEffect(() => {
        if (!isStackItem(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "stackItem", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isStackItem(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, Object.assign({ outlineColor: "blue.50", flex: props.contentElement.data.flex }, combinedContainerProps),
        ref && combinedIsActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Stack Item", position: "left-start", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Proportion"),
                    React.createElement(NumberInput, { value: props.contentElement.data.flex, onChange: (asString, asNumber) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { flex: asNumber }) })) },
                        React.createElement(NumberInputField, null)))),
        React.createElement("div", { ref: setRef },
            React.createElement(ContentArea, { attachControlsTo: ref, showAdd: isActive, contentElements: props.contentElement.data.children, onChange: elements => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { children: elements }) })), allowedTypes: ["stack", "image", "text", "title", "box", "form", "snippet", "button", "faq", "video"] }))));
};
